import {
  Info,
  Target,
  Users,
  Vote,
  FileText,
  TrendingUp,
  Heart,
  DollarSign,
  type LucideIcon,
} from 'lucide-react';

export function About() {
  return (
    <div className='min-h-screen bg-slate-900'>
      <div className='max-w-4xl px-4 py-12 mx-auto'>
        <HeroSection />
        <MissionSection />
        <FeaturesSection />
        <SupportSection />
        <CallToActionSection />
      </div>
    </div>
  );
}

function HeroSection() {
  return (
    <div className='mb-12 text-center'>
      <div className='flex items-center justify-center gap-2 mb-2'>
        <h1 className='text-4xl font-bold text-amber-400'>كلامنتينا</h1>
        <img src='/logo.svg' alt='كلامنتينا Logo' className='w-16 h-16' />
      </div>

      <p className='text-xl text-slate-400'>
        منصة لاقتراح بدائل مصرية للكلمات الأجنبية في اللهجة المصرية
      </p>
    </div>
  );
}

function MissionSection() {
  return (
    <div className='p-6 mb-8 border rounded-lg bg-slate-800 border-slate-700'>
      <div className='flex items-start gap-4 mb-4'>
        <Target className='w-6 h-6 mt-1 text-amber-400' />
        <div>
          <h2 className='mb-3 text-2xl font-bold text-slate-100'>
            ليه كلامنتينا؟
          </h2>
          <p className='mb-3 leading-relaxed text-slate-100'>
            دلوقتي بقينا بنستخدم كلمات أجنبية كتير زي "ميتينج" و"بريزنتيشن"
            و"أبديت" وغيرها، وده بيخلي لغتنا المصرية تضعف. كلامنتينا هي محاولة
            لإيجاد بدائل مصرية سهلة وطبيعية للكلمات دي.
          </p>
          <p className='leading-relaxed text-slate-100'>
            احنا مش بنحاول نفرض حاجة ولا بنحكم على حد كل واحد يتكلم بالطريقة
            اللي تريحه، بس احنا بنشجع المجتمع يفكر ويقترح بدائل بالتحديد للكلمات
            اللي ملهاش بدائل، ونسيب التصويت يحدد أحسن البدائل اللي ممكن تنتشر
            بشكل طبيعي.
          </p>
        </div>
      </div>
    </div>
  );
}

function FeaturesSection() {
  return (
    <div className='mb-8'>
      <h2 className='mb-6 text-2xl font-bold text-center text-slate-100'>
        إزاي كلامنتينا بتشتغل؟
      </h2>
      <div className='grid gap-6 md:grid-cols-2'>
        <FeatureCard
          icon={Info}
          iconColor='amber'
          title='اكتشف الكلمات'
          description='خد لفة في الكلمات الأجنبية اللي المجتمع اقترح لها بدائل، وشوف البدائل المصرية المقترحة ليها. تقدر تدور وتفلتر حسب الفئة (تكنولوجيا، بيزنس، إلخ).'
        />
        <FeatureCard
          icon={FileText}
          iconColor='amber'
          title='ضيف كلمات جديدة'
          description='لو لقيت كلمة أجنبية بنستخدمها كتير في كلامنا؟ ضيفها على الموقع مع اقتراحك للبديل المصري ليها، وخلي المجتمع يشارك في إيجاد أحسن بديل.'
        />
        <FeatureCard
          icon={TrendingUp}
          iconColor='rose'
          title='اقترح بدائل'
          description='شايف إن في بديل أحسن لكلمة موجودة؟ اقترح البديل بتاعك مع شرح ليه البديل ده مناسب، وإزاي ممكن نستخدمه في جمل.'
        />
        <FeatureCard
          icon={Vote}
          iconColor='rose'
          title='صوت على البدائل'
          description='ساعد المجتمع في اختيار أحسن البدائل من خلال التصويت. البدائل اللي بتاخد أصوات أكتر بتظهر في الأول وبتبقى هي البديل الأشهر.'
        />
        <FeatureCard
          icon={Users}
          iconColor='amber'
          title='الساحة الشعبية'
          description='شوف المساهمين الأكثر نشاطا في الموقع وتابع إنجازاتك وشوف إحصائيات المنصة والكلمات والبدائل الأكثر شهرة.'
          fullWidth
        />
      </div>
    </div>
  );
}

function SupportSection() {
  return (
    <div className='mb-8'>
      <h2 className='mb-6 text-2xl font-bold text-center text-slate-100'>
        ادعم المشروع
      </h2>
      <p className='mb-6 text-center text-slate-400'>
        كلامنتينا مشروع مجاني بالكامل. لو عجبك المشروع وحابب تدعمنا، ممكن
        تساعدنا عشان نستمر!
      </p>
      <div className='grid gap-6 md:grid-cols-2'>
        <SupportCard
          href='https://ko-fi.com/shankat'
          icon={Heart}
          iconColor='amber'
          title='ادعمنا على Ko-fi'
          description='اشترينا قهوة أو ادعمنا بأي مبلغ تحب على منصة Ko-fi'
          buttonText='دعم على Ko-fi'
        />
        <SupportCard
          href='https://checkout.revolut.com/pay/d4507361-8220-4b1a-8910-9d08b9b2dfc4'
          icon={DollarSign}
          iconColor='rose'
          title='ادعمنا على Revolut'
          description='ادعمنا بـ 5 يورو من خلال Revolut بسرعة وأمان'
          buttonText='دعم على Revolut (5 €)'
        />
      </div>
    </div>
  );
}

function CallToActionSection() {
  return (
    <div className='p-8 mt-12 text-center border rounded-lg bg-gradient-to-br from-amber-500/10 to-rose-500/10 border-amber-500/30'>
      <h2 className='mb-4 text-2xl font-bold text-slate-100'>يلا بينــــا</h2>
      <p className='mb-6 text-slate-100'>
        انضم لينا دلوقتي وساعدنا في إحياء اللغة المصرية في كلامنا
      </p>
      <div className='flex flex-wrap justify-center gap-4'>
        <a
          href='/discover'
          className='px-6 py-3 font-semibold transition-all duration-300 rounded-lg bg-amber-500 hover:bg-amber-600 text-slate-900'>
          اكتشف الكلمات
        </a>
        <a
          href='/submit'
          className='px-6 py-3 font-semibold transition-all duration-300 border rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-100 border-slate-700'>
          ضيف كلمة
        </a>
      </div>
    </div>
  );
}

interface FeatureCardProps {
  icon: LucideIcon;
  iconColor: 'amber' | 'rose';
  title: string;
  description: string;
  fullWidth?: boolean;
}

function FeatureCard({
  icon: Icon,
  iconColor,
  title,
  description,
  fullWidth = false,
}: FeatureCardProps) {
  const iconColorClass =
    iconColor === 'amber' ? 'text-amber-400' : 'text-rose-400';
  const iconBgClass =
    iconColor === 'amber' ? 'bg-amber-500/10' : 'bg-rose-500/10';
  const colSpanClass = fullWidth ? 'md:col-span-2' : '';

  return (
    <div
      className={`p-6 transition-all duration-300 border rounded-lg bg-slate-800 border-slate-700 hover:border-slate-600 ${colSpanClass}`}>
      <div className='flex items-start gap-4'>
        <div className={`p-3 rounded-lg ${iconBgClass}`}>
          <Icon className={`w-6 h-6 ${iconColorClass}`} />
        </div>
        <div>
          <h3 className='mb-2 text-lg font-semibold text-slate-100'>{title}</h3>
          <p className='text-slate-400'>{description}</p>
        </div>
      </div>
    </div>
  );
}

interface SupportCardProps {
  href: string;
  icon: LucideIcon;
  iconColor: 'amber' | 'rose';
  title: string;
  description: string;
  buttonText: string;
}

function SupportCard({
  href,
  icon: Icon,
  iconColor,
  title,
  description,
  buttonText,
}: SupportCardProps) {
  const iconColorClass =
    iconColor === 'amber' ? 'text-amber-400' : 'text-rose-400';
  const iconBgClass =
    iconColor === 'amber' ? 'bg-amber-500/10' : 'bg-rose-500/10';
  const borderHoverClass =
    iconColor === 'amber' ? 'hover:border-amber-500' : 'hover:border-rose-500';
  const shadowHoverClass =
    iconColor === 'amber'
      ? 'hover:shadow-amber-500/10'
      : 'hover:shadow-rose-500/10';
  const buttonColorClass =
    iconColor === 'amber' ? 'text-amber-400' : 'text-rose-400';

  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      className={`block p-6 transition-all duration-300 border rounded-lg bg-slate-800 border-slate-700 ${borderHoverClass} hover:shadow-lg ${shadowHoverClass}`}>
      <div className='flex items-start gap-4'>
        <div className={`p-3 rounded-lg ${iconBgClass}`}>
          <Icon className={`w-6 h-6 ${iconColorClass}`} />
        </div>
        <div>
          <h3 className='mb-2 text-lg font-semibold text-slate-100'>{title}</h3>
          <p className='mb-4 text-slate-400'>{description}</p>
          <span
            className={`inline-flex items-center gap-2 text-sm font-semibold ${buttonColorClass}`}>
            {buttonText}
            <span>→</span>
          </span>
        </div>
      </div>
    </a>
  );
}
